var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "ChatroomList",
      "extra-items": ['聊天室訊息列表']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("聊天室訊息列表")])])]), _c('button', {
    staticClass: "mt-3 mb-2 btn btn-outline-danger btn-inverse-danger",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("回上一頁")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.messages,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(sender_name)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.sender_name.length > 20 ? data.item.sender_name.slice(0, 20) + "..." : data.item.sender_name) + " ")];
      }
    }, {
      key: "cell(content)",
      fn: function fn(data) {
        return [data.item.content ? _c('div', {
          staticClass: "content"
        }, [_vm._v(" " + _vm._s(data.item.content) + " ")]) : _vm._e()];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    staticClass: "separated",
    attrs: {
      "total-rows": _vm.total,
      "per-page": _vm.perPage,
      "aria-controls": "messageList"
    },
    on: {
      "change": function change(page) {
        return _vm.fetchMessages(page);
      }
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }